import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'


Vue.use(Router);

function lazyLoad(view){
    return() => import(`@/views/${view}.vue`)
}



let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'homepage',
            component: lazyLoad("homepage"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/garage-material/:action',
            name: 'garage-material',
            component: lazyLoad("garage-material"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/garage-material',
            name: 'garage-material',
            component: lazyLoad("garage-material"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/material-climbing-wall/:action',
            name: 'material-climbing-wall',
            component: lazyLoad("material-climbing-wall"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/material-climbing-wall',
            name: 'material-climbing-wall',
            component: lazyLoad("material-climbing-wall"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/attendance-sheet',
            name: 'attendance-sheet',
            component: lazyLoad("attendance-sheet"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/students',
            name: 'students',
            component: lazyLoad("students"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/video',
            name: 'video',
            component: lazyLoad("video"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/courses',
            name: 'courses',
            component: lazyLoad("courses"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/texts',
            name: 'texts',
            component: lazyLoad("texts"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/users',
            name: 'users',
            component: lazyLoad("users"),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: lazyLoad("login"),
        },
        {
            path: '/registration',
            name: 'registration',
            component: lazyLoad("registration"),
        },
        {
            path: '*',
            name: '',
            component: lazyLoad("login"),
        }
    ]
});

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next();
            return
        }
        next('/login')
    } else {
        next()
    }
});

export default router
